import { Truck } from "lucide-react";
import React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from "../../../../components/ui/common/alert-dialog";

interface ChemicalTransportPromptDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  onDecline: () => void;
}

const ChemicalTransportPromptDialog: React.FC<ChemicalTransportPromptDialogProps> = ({
  open,
  onOpenChange,
  onConfirm,
  onDecline
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent className="tw-max-w-xl ">
      <AlertDialogHeader>
        <AlertDialogTitle className="tw-flex tw-items-center tw-gap-2 tw-text-xl">
          <span className="tw-flex tw-h-9 tw-w-9 tw-items-center tw-justify-center tw-rounded-full tw-bg-primary/10">
            <Truck className="tw-h-4 tw-w-4 tw-text-primary" />
          </span>
          Add chemical transportation details?
        </AlertDialogTitle>
        <AlertDialogDescription className="tw-text-md tw-font-normal tw-text-muted-foreground">
          Capturing how this chemical is transported to your facility — transport mode and distance
          — improves the accuracy of upstream emissions and cost calculations. Would you like to
          add transportation details for this chemical now?
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter className="tw-flex tw-flex-row tw-justify-end tw-gap-2 tw-mt-1 tw-sm:tw-space-x-0">
        <AlertDialogCancel className="tw-mt-0" onClick={onDecline}>
          Not now
        </AlertDialogCancel>
        <AlertDialogAction className="tw-mt-0" onClick={onConfirm}>
          Yes, add transport
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);

export default ChemicalTransportPromptDialog;
